
export default {
  name: "Header",
  props: {
    subtitle: String,
  },
};
